import { Avatar, Input, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import EditableBox from "../../edit/EditableBox";

/**
 * 
 * @param {{accountChanged:Function}} props {accountChanged} - function that accepts object: { accountId, name, email, phone }
 * @returns 
 */
export function EditableAddNewAccount({accountChanged}) {

    const [changedProperties, setChangedProperties] = useState() // { accountId, name, email, phone }

    const handleEditNewAccountCancel = (event) => {
        console.log('handleEditNewAccountCancel')
    }

    const handleEditNewAccountDone = async (event) => {
        console.log('handleEditNewAccountDone')
        if (accountChanged && typeof(accountChanged) === 'function') {
            accountChanged(changedProperties)
        }
    }

    /**
     * 
     * @param {{accountId:String, name:String, email:String, phone:String}} changedProperties
     */
    const handleNewAccountChange = (changedProperties) => {
        console.log('handleNewAccountChange changedProperties', changedProperties)
        setChangedProperties(changedProperties)
    }
    
    const editComponent = <EditAddNewAccount onNewAccountChange={handleNewAccountChange} />
    return (
        <EditableBox edit={editComponent} onCancel={handleEditNewAccountCancel} onDone={handleEditNewAccountDone}>
            <DisplayAddNewAccount />
        </EditableBox>
    )
}

function DisplayAddNewAccount(props) {
    return (
        <Box>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar alt="Add New Account" />
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h6" color="secondary">New Account</Typography>
                        </>
                    }
                />
            </ListItem>
        </Box>
    )
}

function EditAddNewAccount({onNewAccountChange}) {
    const [accountId, setAccountId] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    useEffect(() => {
        if (onNewAccountChange && typeof(onNewAccountChange) === 'function') {
            onNewAccountChange({accountId, name, email, phone})
        }
    // (linter is worried about onNewAccountChange but it's an output function)
    // eslint-disable-next-line 
    }, [accountId, name, email, phone])

    const handleAccountIdChange = (event, index) => {
      console.log('handleAccountIdChange')
      setAccountId(event.target.value)
    }

    const handleAccountNameChange = (event, index) => {
        console.log('handleAccountNameChange')
        setName(event.target.value)
    }

    const handleEmailChange = (event, index) => {
        console.log('handleEmailChange')
        setEmail(event.target.value)
    }

    const handlePhoneChange = (event, index) => {
      console.log('handlePhoneChange')
      setPhone(event.target.value)
    }

    return (
        <Box>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar alt="Add New Account" />
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h6" color="secondary" sx={{pb: 2}}>
                                <Input value={accountId} type="text" placeholder="Account ID in Salesforce" onChange={handleAccountIdChange}/>
                            </Typography>
                            <Typography variant="h6" color="secondary" sx={{pb: 2}}>
                                <Input value={name} type="text" placeholder="Account Name" onChange={handleAccountNameChange}/>
                            </Typography>
                            <Typography variant="body2" color="secondary" sx={{pb: 2}}>
                                <Input value={email} type="email" placeholder="Email" onChange={handleEmailChange}/>
                            </Typography>
                            <Typography variant="body2" color="secondary" sx={{pb: 2}}>
                              <Input value={phone} type="text" placeholder="Phone" onChange={handlePhoneChange} />
                            </Typography>
                        </>
                    }
                />
            </ListItem>
        </Box>
    )
}